import AlinPatronImg from 'images/about-us/redesign/AlinPatron.webp';
import IvanGalkinImg from 'images/about-us/redesign/IvanGalkin.webp';
import JosephDiMelisImg from 'images/about-us/redesign/JosephDiMelis.webp';
import MihaelaPoiataImg from 'images/about-us/redesign/MihaelaPoiata.webp';
import SergheiBusmachiImg from 'images/about-us/redesign/SergheiBusmachi.webp';
import AnthonyRichImg from 'images/about-us/redesign/AnthonyRich.webp';
import CharlesBurkeCowleyImg from 'images/about-us/redesign/CharlesBurkeCowley.webp';
import DenisMezerImg from 'images/about-us/redesign/DenisMezer.webp';
import IgorPapoImg from 'images/about-us/redesign/IgorPapo.webp';
import JoshuaStewartImg from 'images/about-us/redesign/JoshuaStewart.webp';
import MattLuttonImg from 'images/about-us/redesign/MattLutton.webp';
import RimaNemtuImg from 'images/about-us/redesign/RimaNemtu.webp';
import SergeyBogutskyImg from 'images/about-us/redesign/SergeyBogutsky.webp';
import SergiuRobuImg from 'images/about-us/redesign/SergiuRobu.webp';
import JonWilburnImg from 'images/about-us/redesign/JonWilburn.webp';
import GregoryTheuretImg from 'images/about-us/redesign/GregoryTheuret.webp';
import TrevorClericoImg from 'images/about-us/redesign/TrevorClerico.webp';
import TroyWilsonImg from 'images/about-us/redesign/TroyWilson.webp';
import ToddNelsonImg from 'images/about-us/redesign/ToddNelson.webp';
import AdamCapponiImg from 'images/about-us/redesign/AdamCapponi.webp';
import DavidDolchImg from 'images/about-us/redesign/DavidDolch.webp';
import JalolMurzakhmetovImg from 'images/about-us/redesign/JalolMurzakhmetov.webp';
import JamesFuhrmanImg from 'images/about-us/redesign/JamesFuhrman.webp';
import MichaelGrivesImg from 'images/about-us/redesign/MichaelGrives.webp';
import PaulBurchellImg from 'images/about-us/redesign/PaulBurchell.webp';
import RobertWoodImg from 'images/about-us/redesign/RobertWood.webp';
import TimGablesImg from 'images/about-us/redesign/TimGables.webp';
import TristaParryImg from 'images/about-us/redesign/TristaParry.webp';
import DariaShapiraImg from 'images/about-us/redesign/DariaShapira.webp';

export const AlinPatron = (AlinPatronImg as any).src || AlinPatronImg;
export const IvanGalkin = (IvanGalkinImg as any).src || IvanGalkinImg;
export const JosephDiMelis = (JosephDiMelisImg as any).src || JosephDiMelisImg;
export const MihaelaPoiata = (MihaelaPoiataImg as any).src || MihaelaPoiataImg;
export const SergheiBusmachi = (SergheiBusmachiImg as any).src || SergheiBusmachiImg;
export const AnthonyRich = (AnthonyRichImg as any).src || AnthonyRichImg;
export const CharlesBurkeCowley = (CharlesBurkeCowleyImg as any).src || CharlesBurkeCowleyImg;
export const DenisMezer = (DenisMezerImg as any).src || DenisMezerImg;
export const IgorPapo = (IgorPapoImg as any).src || IgorPapoImg;
export const JoshuaStewart = (JoshuaStewartImg as any).src || JoshuaStewartImg;
export const MattLutton = (MattLuttonImg as any).src || MattLuttonImg;
export const RimaNemtu = (RimaNemtuImg as any).src || RimaNemtuImg;
export const SergeyBogutsky = (SergeyBogutskyImg as any).src || SergeyBogutskyImg;
export const SergiuRobu = (SergiuRobuImg as any).src || SergiuRobuImg;
export const JonWilburn = (JonWilburnImg as any).src || JonWilburnImg;
export const GregoryTheuret = (GregoryTheuretImg as any).src || GregoryTheuretImg;
export const TrevorClerico = (TrevorClericoImg as any).src || TrevorClericoImg;
export const TroyWilson = (TroyWilsonImg as any).src || TroyWilsonImg;
export const ToddNelson = (ToddNelsonImg as any).src || ToddNelsonImg;
export const AdamCapponi = (AdamCapponiImg as any).src || AdamCapponiImg;
export const DavidDolch = (DavidDolchImg as any).src || DavidDolchImg;
export const JalolMurzakhmetov = (JalolMurzakhmetovImg as any).src || JalolMurzakhmetovImg;
export const JamesFuhrman = (JamesFuhrmanImg as any).src || JamesFuhrmanImg;
export const MichaelGrives = (MichaelGrivesImg as any).src || MichaelGrivesImg;
export const PaulBurchell = (PaulBurchellImg as any).src || PaulBurchellImg;
export const RobertWood = (RobertWoodImg as any).src || RobertWoodImg;
export const TimGables = (TimGablesImg as any).src || TimGablesImg;
export const TristaParry = (TristaParryImg as any).src || TristaParryImg;
export const DariaShapira = (DariaShapiraImg as any).src || DariaShapiraImg;
